import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImageViewerComponent implements OnInit {
  image: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      image: string;
    },
    private _dialogRef: MatDialogRef<ImageViewerComponent>,
    private router: Router,
  ) {
    this.image = this.data.image;
  }

  ngOnInit(): void {}
}
